/*
 * @Author: whb
 * @Date: 2023-01-11 17:55:54
 * @LastEditors: whb
 * @LastEditTime: 2023-01-13 16:11:51
 * @Description: 快捷跳转
 */
import i18n from "../../i18n";
import './index.scss';
const Shortcuts = (props) => {
  const doJump = (key) => {
    props.hide();
    setTimeout(() => {
      const top = document.querySelector(`.${key}`).offsetTop;
      window.scrollTo({
        top: top - 130,
        behavior: 'smooth'
      });
    }, 0);
  };
  return (
    <div className="shortcuts px-44">
      <div className="shortcutsTitle">{props.langs[i18n.shortcutsTitle]}</div>
      <div className="shortcuts-main">
        {props.list &&
          props.list.map((item) => {
            return (
              <div
              className={['shortcuts-item', item.key].join(' ')}
                key={item.key}
                dangerouslySetInnerHTML={{__html: item.value}}
                onClick={() => doJump(item.key)}
              ></div>
            );
          })}
      </div>
    </div>
  );
};
export default Shortcuts;
